import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { toast } from "sonner";
import axiosInstance from "../../../Axios";
import useAuth from "../../../contexts/UserContext.tsx";

const DeactivateModal = ({ open, onClose, centerId }) => {
  const [requestedBy, setRequestedBy] = useState("");
  const [comments, setComments] = useState("");
  const { user } = useAuth();

  const handleDeactivate = () => {
    console.log("Deactivating center id: ", centerId);
    if (requestedBy === "") {
      toast.error("Requested By is required");
      return;
    } else if (comments === "") {
      toast.error("Comments are required");
      return;
    }
    const data = {
      user_id: user.user_id,
      auth_token: user.auth_token,
      center_id: centerId,
      requested_by: requestedBy,
      comments: comments,
    };
    axiosInstance
      .post("deactivateCenter", {
        ...data,
      })
      .then(() => {
        toast.success("Center Deactivated Successfully");
        onClose();
      })
      .catch(() => {
        toast.error("Error deactivating center");
      });
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="deactivation-form">
      <DialogTitle id="form-dialog-title">Center ID Deactivation</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="requested_by"
          label="Requested By"
          type="text"
          value={requestedBy}
          onChange={(e) => setRequestedBy(e.target.value)}
          fullWidth
        />
        <TextField
          autoFocus
          margin="dense"
          id="comments"
          label="Comments"
          type="comments"
          fullWidth
          value={comments}
          onChange={(e) => setComments(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleDeactivate();
          }}
          color="primary"
        >
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeactivateModal;
